import { defineMessages } from "react-intl";

export const scope = "app.components.Message";

export default defineMessages({
  appointment_planned_title: {
    id: `${scope}.appointment_planned_title`,
    defaultMessage: "Appointment planned",
  },
  appointment_changed_title: {
    id: `${scope}.appointment_changed_title`,
    defaultMessage: "Appointment changed",
  },
  appointment_deleted_title: {
    id: `${scope}.appointment_deleted_title`,
    defaultMessage: "Appointment cancelled",
  },
  order_placed_title: {
    id: `${scope}.order_placed_title`,
    defaultMessage: "Order placed",
  },
  order_changed_title: {
    id: `${scope}.order_changed_title`,
    defaultMessage: "Order updated",
  },
  order_message: {
    id: `${scope}.order_message`,
    defaultMessage: "Order message",
  },
  close_treatmentplan_message: {
    id: `${scope}.close_treatmentplan_message`,
    defaultMessage: "Treatmentplan closed",
  },
  close_productplan_message: {
    id: `${scope}.close_productplan_message`,
    defaultMessage: "Productplan closed",
  },
  order_placed_upper_product: {
    id: `${scope}.order_placed_upper_product`,
    defaultMessage: "Product upper jaw",
  },
  order_placed_lower_product: {
    id: `${scope}.order_placed_lower_product`,
    defaultMessage: "Product lower jaw",
  },
  order_placed_phase: {
    id: `${scope}.order_placed_phase`,
    defaultMessage: "Treatment phase",
  },
  order_placed_thanks: {
    id: `${scope}.order_placed_thanks`,
    defaultMessage: "Thank you for placing an order!",
  },
  order_changed_thanks: {
    id: `${scope}.order_changed_thanks`,
    defaultMessage:
      "Thank you for updating your order. We will continue immediately!",
  },
  order_placed_order: {
    id: `${scope}.order_placed_order`,
    defaultMessage: "Order",
  },
  order_changed_message: {
    id: `${scope}.order_changed_message`,
    defaultMessage: "Message",
  },
  order_placed_delivery_date: {
    id: `${scope}.order_placed_delivery_date`,
    defaultMessage: "Expected delivery date",
  },
  order_placed_full_order_action: {
    id: `${scope}.order_placed_full_order_action`,
    defaultMessage: "View complete order",
  },
  order_changed_message_read: {
    id: `${scope}.order_changed_message_read`,
    defaultMessage: "Okay, message read",
  },
  order_placed_edit_action: {
    id: `${scope}.order_placed_edit_action`,
    defaultMessage: "Change / cancel order",
  },
  order_placed_next_order_action: {
    id: `${scope}.order_placed_next_order_action`,
    defaultMessage: "schedule follow-up order",
  },
  order_placed_reorder_action: {
    id: `${scope}.order_placed_reorder_action`,
    defaultMessage: "Reorder try-in / placement",
  },
  order_placed_popover_info: {
    id: `${scope}.order_placed_popover_info`,
    defaultMessage:
      "This date is indicative and can be changed by possible adjustments.",
  },
  contact_refrezh_title: {
    id: `${scope}.contact_refrezh_title`,
    defaultMessage: "PLEASE CONTACT REFREZH",
  },
  contact_refrezh_text: {
    id: `${scope}.contact_refrezh_text`,
    defaultMessage:
      "You want to make a change or cancellation to an order whose production has already started. Contact ReFrezh by telephone so that together we can provide a suitable solution and can change or cancel the order.",
  },
  contact_refrezh_contact: {
    id: `${scope}.contact_refrezh_contact`,
    defaultMessage: "Call ReFrezh: 088-700 5588",
  },
  upload_stl_title: {
    id: `${scope}.upload_stl_title`,
    defaultMessage: "Upload STL-files",
  },
  order_incomplete: {
    id: `${scope}.order_incomplete`,
    defaultMessage: "Order incomplete",
  },
  by_user_name: {
    id: `${scope}.by_user_name`,
    defaultMessage: "By: {name}",
  },
  upload_stl_message: {
    id: `${scope}.upload_stl_message`,
    defaultMessage:
      "To continue case number {caseNumber} you still have to upload files.",
  },
  incomplete_order: {
    id: `${scope}.incomplete_order`,
    defaultMessage:
      "To continue case number {caseNumber} you have to confirm the order.",
  },
  upload_stl_confirm: {
    id: `${scope}.upload_stl_confirm`,
    defaultMessage: "Go to order",
  },
  upload_stl_done: {
    id: `${scope}.upload_stl_done`,
    defaultMessage: "Settled on {date}",
  },
  upload_stl_info: {
    id: `${scope}.upload_stl_info`,
    defaultMessage:
      "No STL files were uploaded during the order process. Unfortunately, the order cannot start because of this and no expected delivery date can be given. As soon as we receive the files we will start the order and issue an expected delivery date.",
  },
  upload_extra_stl_title: {
    id: `${scope}.upload_extra_stl_title`,
    defaultMessage: "Upload additional STL-files",
  },
  upload_extra_stl_message: {
    id: `${scope}.upload_extra_stl_message`,
    defaultMessage:
      "To continue case number {caseNumber} you have to upload extra files.",
  },
  upload_extra_stl_confirm: {
    id: `${scope}.upload_extra_stl_confirm`,
    defaultMessage: "Finished uploading",
  },
  upload_extra_stl_info: {
    id: `${scope}.upload_extra_stl_info`,
    defaultMessage:
      "The supplied files are incomplete or not in order. Unfortunately, the order is now on hold and the expected delivery date may change. As soon as we receive the new / extra STL files, we will start the order and issue a new expected delivery date.",
  },
  upload_extra_stl_reason: {
    id: `${scope}.upload_extra_stl_reason`,
    defaultMessage: "Reason for request",
  },
  planned_treatment_thanks: {
    id: `${scope}.planned_treatment_thanks`,
    defaultMessage: "Thank you for your scheduled appointment!",
  },
  planned_treatment_case_nr: {
    id: `${scope}.planned_treatment_case_nr`,
    defaultMessage: "Case no.",
  },
  planned_treatment_date: {
    id: `${scope}.planned_treatment_date`,
    defaultMessage: "Date",
  },
  planned_treatment_kpt: {
    id: `${scope}.planned_treatment_kpt`,
    defaultMessage: "KPT",
  },
  planned_treatment_comment: {
    id: `${scope}.planned_treatment_comment`,
    defaultMessage: "Comment",
  },
  planned_treatment_time: {
    id: `${scope}.planned_treatment_time`,
    defaultMessage: "Time",
  },
  planned_treatment_appointment: {
    id: `${scope}.planned_treatment_appointment`,
    defaultMessage: "View appointment",
  },
  planned_treatment_edit_appointment: {
    id: `${scope}.planned_treatment_edit_appointment`,
    defaultMessage: "Change / cancel appointment",
  },
  planned_treatment_next_appointment: {
    id: `${scope}.planned_treatment_next_appointment`,
    defaultMessage: "Schedule follow-up appointment",
  },
  planned_treatment_changed_thanks: {
    id: `${scope}.planned_treatment_changed_thanks`,
    defaultMessage: "Your appointment {name} has been changed successfully!",
  },
  planned_treatment_deleted_thanks: {
    id: `${scope}.planned_treatment_deleted_thanks`,
    defaultMessage: "Your appointment has been canceled!",
  },
  message_loading: {
    id: `${scope}.message_loading`,
    defaultMessage: "Loading messages",
  },
  general_message_title: {
    id: `${scope}.general_message_title`,
    defaultMessage: "Dashboard update",
  },
  general_message_read: {
    id: `${scope}.general_message_read`,
    defaultMessage: "Okay, message read",
  },
  order_placed_remake_action: {
    id: `${scope}.order_placed_remake_action`,
    defaultMessage: "Remake request",
  },
  order_placed_warranty_action: {
    id: `${scope}.order_placed_warranty_action`,
    defaultMessage: "Warranty request",
  },
  order_placed_without_deliverydate: {
    id: `${scope}.order_placed_without_deliverydate`,
    defaultMessage:
      "The delivery date is determined once all files have been processed.",
  },
  has_home_treatments: {
    id: `${scope}.has_home_treatments`,
    defaultMessage: "Home treatments",
  },
  has_been_planned: {
    id: `${scope}.has_been_planned`,
    defaultMessage: "Your appointment {name} has been planned successfully",
  },
  order_changed_from: {
    id: `${scope}.order_changed_from`,
    defaultMessage: "from",
  },
  order_changed_to: {
    id: `${scope}.order_changed_to`,
    defaultMessage: "to",
  },
  order_changed_change: {
    id: `${scope}.order_changed_change`,
    defaultMessage: "Change",
  },
});
